import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=522fc4b3"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports